import React from 'react';
interface BonusCardProps {
  title: string;
  image: string;
}
export function BonusCard({
  title,
  image
}: BonusCardProps) {
  return <a href="#comprar" className="bg-zinc-900 border border-[#F59E0B]/30 rounded-xl overflow-hidden flex flex-col relative cursor-pointer transition-transform hover:scale-105 no-underline" data-id="element-189">
      <div className="absolute top-3 right-3 bg-red-600 text-white text-xs font-black px-3 py-1 rounded-full uppercase tracking-wider z-10 shadow-lg" data-id="element-190">
        GRATIS
      </div>
      <div className="h-48 overflow-hidden bg-black flex items-center justify-center p-4" data-id="element-191">
        <img src={image} alt={title} className="h-full object-contain filter drop-shadow-2xl" data-id="element-192" />
      </div>
      <div className="p-5 bg-zinc-800/50 flex-1 flex items-center justify-center text-center" data-id="element-193">
        <h4 className="font-bold text-lg text-white" data-id="element-194">{title}</h4>
      </div>
    </a>;
}